import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CONSENT_CHANGED_EVENT, trackPageView } from '../utils/analytics';

/**
 * Sends GA4 page views from React Router's location: on load, on every route
 * change and right after the visitor accepts analytics cookies. Only the
 * pathname is used (query strings and fragments can carry auth codes or
 * Stripe session ids). No-op unless GA4 is configured and accepted.
 * Must render inside the Router.
 */
export const AnalyticsPageViews: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  useEffect(() => {
    const onConsentChanged = () => {
      trackPageView(window.location.pathname);
    };
    window.addEventListener(CONSENT_CHANGED_EVENT, onConsentChanged);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onConsentChanged);
  }, []);

  return null;
};

export default AnalyticsPageViews;
